import * as React from "react";
import { useTranslation } from "react-i18next";

import LicensesTable from "./LicensesTable";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { VideoTutorialButton } from "components/modal/video-modal/video-tutorial-button/VideoTutorialButton";
import { VideoModal } from "components/modal/video-modal/VideoModal";
import { LICENSES_ROUTE } from "components/router/Routes";
import { TutorialVideoLink } from "domain/tutorialVideos";

export default function MyLicensesView(): JSX.Element {
    const { t } = useTranslation();
    const [showVideoModal, setShowVideoModal] = React.useState(false);
    const watchTutorialButton = <VideoTutorialButton onClick={() => setShowVideoModal(true)} />;

    return (
        <>
            <ApplicationLayout
                viewTitle={t("Licenses.myLicenses")}
                view={<LicensesTable own={true} />}
                mainRoute={LICENSES_ROUTE}
                viewActions={watchTutorialButton}
                hideActions={watchTutorialButton}
            />
            <VideoModal
                isOpen={showVideoModal}
                hideModal={() => setShowVideoModal(false)}
                linkUrl={TutorialVideoLink.LICENSES}
            />
        </>
    );
}
